<template>
  <b-card no-body>
    <b-card-header>
      <b-row align-v="center">
        <b-col cols="8">
          <h3 class="mb-0">Edit profile</h3>
        </b-col>
      </b-row>
    </b-card-header>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(updateProfile)">
        <b-card-body>
          <h6 class="heading-small text-muted mb-4">Personal information</h6>

          <div class="pl-lg-4">
            <b-row>
              <b-col lg="6">
                <base-input
                  type="text"
                  label="First Name"
                  placeholder="First Name"
                  v-model="model.firstName"
                  :rules="{ required: false }"
                  :debounce="500"
                ></base-input>
              </b-col>
              <b-col lg="6">
                <base-input
                  type="text"
                  label="Last Name"
                  placeholder="Last Name"
                  v-model="model.lastName"
                  :rules="{ required: false }"
                  :debounce="500"
                ></base-input>
              </b-col>
            </b-row>
          </div>

          <hr class="my-4" />
          <!-- Description -->
          <h6 class="heading-small text-muted mb-4">Profile picture</h6>
          <div class="pl-lg-4">
            <b-row>
              <b-col lg="3">
                <img :src="user.avatarUrl" class="img img-fluid rounded" />
              </b-col>
              <b-col lg="9">
                <p>
                  Profile pictures are managed by
                  <a
                    target="_blank"
                    href="https://en.gravatar.com/support/what-is-gravatar/"
                  >Gravatar</a>.
                  Please follow
                  <a
                    href="https://en.gravatar.com/support/how-to-sign-up/"
                    target="_blank"
                  >these instructions</a> to create or update your Gravatar account.
                </p>
                <div class="text-right">
                  <b-button variant="link" href="https://wordpress.com/me" target="_blank">
                    Gravatar settings
                    <i class="fa fa-arrow-right ml-2"></i>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-card-body>

        <b-card-footer class="text-right">
          <base-button type="primary" native-type="submit">
            <span v-if="!isUpdating">
              Save
              <i class="fa fa-save ml-2"></i>
            </span>
            <span v-else>
              Please wait&hellip;
              <i class="fa fa-spin fa-spinner"></i>
            </span>
          </base-button>
        </b-card-footer>
      </b-form>
    </validation-observer>
  </b-card>
</template>
<script>
export default {
  data() {
    return {
      model: {
        firstName: null,
        lastName: null
      },
      isUpdating: false,
      errorMessage: null
    };
  },
  computed: {
    user() {
      return this.$auth.user();
    }
  },
  created() {
    // set auth.user() to form model
    this.model.firstName = this.$auth.user().firstName;
    this.model.lastName = this.$auth.user().lastName;
  },
  methods: {
    updateProfile() {
      this.isUpdating = true;

      const body = {};

      if (this.model.firstName) {
        body.firstName = this.model.firstName;
      }

      if (this.model.lastName) {
        body.lastName = this.model.lastName;
      }

      this.axios
        .patch(`/v1/users/current`, body)
        .then(response => {
          this.isUpdating = false;
          this.model = response.data;
          this.$auth.user(response.data);

          this.$notify({
            message: "Profile updated",
            timeout: 2000,
            icon: "fa fa-check",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(error => {
          this.isUpdating = false;
          let errorMessage = "Error updating profile";
          this.$notify({
            message: errorMessage,
            timeout: 2000,
            icon: "fa fa-exclamation-triangle",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger"
          });
        });
    }
  }
};
</script>
<style></style>
